import React from 'react'

import { TextContent } from 'common/builder/components/chart/FlowChart/components/Block/components/TextContent/TextContent'
import { EmailContentWrapper } from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/components/EmailContentWrapper/EmailContentWrapper'
import { EmailContentComponent } from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/types'
import { useTextContentParts } from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'
import { EmailContentText } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

export const EmailContentTextComponent: EmailContentComponent<EmailContentText> = (props) => {
  const { textContent } = useTextContentParts(props.content.data.text)

  return (
    <EmailContentWrapper>
      <TextContent content={textContent} buttons={props.content.data.buttons} />
    </EmailContentWrapper>
  )
}
